module.exports = __webpack_public_path__ + "static/media/govo_loading.777e7b2a.gif";